<template>
  <div>
    <div class="actTop_info">
      <div class="actTop_infoText" v-text="actTime"></div>
      <div class="actTop_infoText ismobile" id="logined" v-show="isLogin">
        <div>
          你好，
          <span class="actTop_name" id="userinfo"></span>
          <span class="actTop_name">{{ bindPartitionName }}</span>
          <span class="actTop_name">{{ bindRoleName }}</span>
        </div>
        <div class="actTop_InfoUser">
          <a
            href="javascript:;"
            v-show="bindRole === '1'"
            class="actTop_InfoLink"
            @click="areaIsShow()"
            >{{ area.optTitle }}</a
          >
          <a
            href="javascript:;"
            v-if="personMsg === '1'"
            class="actTop_InfoLink"
            @click="infoIsShow()"
            >个人信息</a
          >
          <a
            href="javascript:;"
            v-if="record === '1'"
            class="actTop_InfoLink"
            @click="recordIsShow('1', true)"
            >领奖记录</a
          >
        </div>
        <div>
          <a href="javascript:;" id="ptLogoutBtn" @click="quit()">退出</a>
        </div>
      </div>
      <div class="actTop_infoText" id="unlogin" v-show="!isLogin">
        你好，请
        <span v-show="(loginType === '1' || loginType === '2') && !isLogin"
          ><a
            href="javascript:;"
            class="actTop_login"
            id="ptLoginBtn"
            @click="qcLogin()"
            >【QQ登录】</a
          ></span
        >
        <span
          v-show="
            (loginType === '1' || loginType === '3') && !isLogin && wxBrowser
          "
          >或<a
            href="javascript:;"
            class="actTop_login"
            id="wxloginBtn"
            @click="wxLogin()"
            >【微信登录】</a
          ></span
        >
      </div>
    </div>
    <!-- 弹窗开始-->
    <div class="actModal" v-show="areaModal" id="areaModalH5">
      <div class="actModal_content areaContent">
        <a
          href="javascript:;"
          class="actModal_closeBtn"
          @click="areaModalClose()"
        >
          关闭
        </a>
        <div class="actModal_header">
          <h3 v-text="area.title"></h3>
        </div>
        <div>
          <ul class="actModal_ul">
            <li class="actModal_li">
              <select
                @change="queryRole()"
                id="partition"
                v-model="partitionId"
              >
              </select>
            </li>
            <li class="actModal_li">
              <select id="role">
                <option
                  v-for="(job, index) in jobs.content"
                  :key="index"
                  :value="job.roleId"
                  v-text="job.roleName"
                ></option>
              </select>
            </li>
          </ul>
        </div>
        <div class="actModal_footer">
          <a
            href="javascript:;"
            @click="subBindRole()"
            class="actModal_footerBtn"
            >保存</a
          >
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
    <!-- 弹窗开始-->
    <div class="actModal" v-show="areaModalPC" id="areaModalPC">
      <div class="actModal_content areaContent">
        <a
          href="javascript:;"
          class="actModal_closeBtn"
          @click="areaModalClose()"
        >
          <span></span>
        </a>
        <div class="actModal_header">
          <h3 v-text="area.title"></h3>
        </div>
        <div>
          <ul>
            <li class="actModal_li">
              <select @change="showSenPar()" v-model="pcArea" id="PCpartition">
                <option
                  v-for="(area, index) in area.content"
                  :key="index"
                  :value="area.value"
                  v-text="area.name"
                ></option>
              </select>
            </li>
            <li
              class="actModal_li"
              @change="pcQueryRole()"
              style="position: relative;"
              id="PCSenPartition"
              v-if="area.secondPar"
            >
              <select v-model="partitionId" id="pcSenPar">
                <option
                  v-for="(area, index) in area.secondPar"
                  :key="index"
                  :value="area.value"
                  v-text="area.name"
                ></option>
              </select>
            </li>
            <li class="actModal_li">
              <select id="pcRole" v-model="roleId">
                <option
                  v-for="(job, index) in jobs.content"
                  :key="index"
                  :value="job.roleId"
                  v-text="job.roleName"
                ></option>
              </select>
            </li>
          </ul>
        </div>
        <div class="actModal_footer">
          <a
            href="javascript:;"
            @click="pcSubBindRole()"
            class="actModal_footerBtn"
          ></a>
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
    <!-- 弹窗开始-->
    <div class="actModal" v-if="infoModal">
      <div class="actModal_content areaContent">
        <a
          href="javascript:;"
          class="actModal_closeBtn"
          @click="infoModalClose()"
        >
          <span></span>
        </a>
        <div class="actModal_header">
          <h3 v-text="info.title"></h3>
        </div>
        <div>
          <div class="actModal_bodyTitle" v-text="info.content"></div>
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
    <!-- 弹窗开始-->
    <div class="actModal" v-if="recordModal">
      <div class="actModal_content recordContent">
        <a
          href="javascript:;"
          class="actModal_closeBtn"
          @click="recodeModalClose()"
        >
          <span></span>
        </a>
        <div class="actModal_header">
          <h3 v-text="awards.title"></h3>
        </div>
        <div>
          <div class="actModal_awardsList">
            <table>
              <thead>
                <tr>
                  <td width="140">道具名称</td>
                  <td width="200">领取时间</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(awards, index) in awards.content" :key="index">
                  <td v-text="awards.name"></td>
                  <td v-text="awards.time"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="actModal_awardsPages">
            <a
              href="javascript:;"
              class="actModal_awardsPagesBtn"
              @click="recordIsShow(awards.pageNow - 1)"
              >上一页</a
            >
            <input
              readonly="readonly"
              class="actModal_awardsPagesInput"
              v-model="awards.pageNow"
            />
            <a
              href="javascript:;"
              class="actModal_awardsPagesBtn"
              @click="recordIsShow(awards.pageNow + 1)"
              >下一页</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
  </div>
</template>
<script>
import './../../assets/css/reset.css';
import bus from '../../../bus';
import { mixins } from '../../../src/h5mixins';
import { setTimeout } from 'timers';
import { report } from '../buryingPoint/index';
import { gCodeServerselect } from '../../assets/js/gCodeServerselect';
export default {
	name: 'h5-signIn',
	mixins: mixins,
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			loginType: '登陆方式',
			bindRole: '是否绑定大区',
			personMsg: '是否展示个人信息',
			record: '是否展示领奖记录',
			actTime: '活动时间',
			queryRoleFlowId: '查询角色列表',
			bindRoleFlowId: '绑定换绑角色',
			queryHistoryRoleFlowId: '查询绑定角色',
			giftRecordFlowId: '查询个人获奖记录',
			gitfIsGeted: '礼包状态查询',
			showType: '机型展示查询'
		}
	},
	props: {
		loginType: {
			type: String,
			default: '1' // 登陆类型：1表示QQ+微信登陆，2表示QQ登陆，3表示微信登陆，4表示不登陆
		},
		bindRole: {
			type: String,
			default: '1' // 绑定大区：1表示有绑定大区操作，0表示不绑定大区
		},
		personMsg: {
			type: String,
			default: '0' // 个人信息：1表示有绑定个人信息操作，0表示不展示个人信息
		},
		record: {
			type: String,
			default: '1' // 领奖记录：1表示有领奖记录操作，0表示展示领奖记录
		},
		actTime: {
			type: String,
			default: ''
		},
		queryRoleFlowId: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '查询角色列表',
							value: ''
						}
					}
				];
			}
		},
		bindRoleFlowId: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '绑定换绑角色',
							value: ''
						}
					}
				];
			}
		},
		queryHistoryRoleFlowId: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '查询绑定角色',
							value: ''
						}
					}
				];
			}
		},
		giftRecordFlowId: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '查询个人获奖记录',
							value: ''
						}
					}
				];
			}
		},
		gitfIsGeted: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '礼包状态查询',
							value: ''
						}
					}
				];
			}
		},
		showType: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '机型展示查询',
							value: ''
						}
					}
				];
			}
		}
	},
	data () {
		return {
			isLogin: false,
			areaModal: false,
			jsBindIsLoad: false,
			area: {
				optTitle: '绑定大区',
				title: '绑定大区',
				content: [],
				secondPar: [{ value: '0', name: '请选择小区' }]
			},
			$gameCode: '',
			jobs: {
				title: '',
				content: [{ roleId: '0', roleName: '请选择角色' }]
			},
			areaModalPC: false,
			infoModal: false,
			info: {
				title: '个人信息',
				content:
          '自定义自定义自定义自定义自定自定义自定义自定义自定义自定自定义自定义自定义自定义自定自定义自定义自定义自定义自定'
			},
			recordModal: false,
			awards: {
				totalPage: 1,
				pageNow: 1,
				title: '领奖记录',
				content: []
			},
			loginInfo: {},
			nickName: null,
			partitionName: null,
			roleName: null,
			isIos: false,
			isAndroid: false,
			wxBrowser: false,
			partitionId: 0, // 小区id
			roleId: 0, // 角色id
			sArea: 1, // 微信账号为1，QQ账号为2
			sPlatId: '2', // 平台编号：ios是2，安卓是1
			sAreaName: '', // 区服名称
			sRoleName: '', // 角色名称
			bindRoleId: 0, // 已经绑定的角色id
			bindRoleName: '', // 已经绑定的角色名
			bindPartitionId: 0, // 已经绑定的大区id
			bindPartitionName: '', // 已经绑定的大区名
			pcArea: '-1'
		};
	},
	mounted () {
		if (this.$actMode !== 'production') {
			return;
		}
		window.gCodeServerselect = gCodeServerselect;
		const appid = window.milo.cookie.get('appid');
		if (appid && !['wxfb66a4e99e630765', '101813972'].includes(appid)) {
			this.quit();
		}
		const openid = window.milo.cookie.get('openid');
		if (openid && appid) {
			window.validate = false;
		} else {
			window.validate = true;
		}
		this.getLogin();
		this.init_login();
		this.isIos = /ipad|iphone|ipod/gi.test(navigator.userAgent.toLowerCase());
		this.isAndroid = /linux|android/gi.test(navigator.userAgent.toLowerCase());
		this.wxBrowser = /micromessenger/gi.test(navigator.userAgent.toLowerCase());
	},
	computed: {},
	methods: {
		// 初始化登录
		init_login () {
			let _self = this;
			let that = this;
			if (window.milo.cookie.get('acctype') !== 'qc') {
				window.iUseQQConnect = 0;
			} else {
				window.iUseQQConnect = 1;
			}
			let loginConfig = _self.getLoginConfig();
			_self.$miloLogin().then(LoginManager => {
				if (typeof LoginManager.init === 'undefined') {
					return;
				}
				LoginManager.init(loginConfig);
				window.milo.cookie.clear('IED_LOG_INFO2', '.qq.com', '/');
				window.milo.cookie.clear('IED_LOG_INFO2_QC', '.xinyue.qq.com', '/');
				window.milo.cookie.clear('wxnickname', '.qq.com', '/');
				LoginManager.checkLogin(
					userInfo => {
						// that.isLogin = true
						that.loginInfo = userInfo;
						if (window.milo.cookie.get('acctype') === 'wx') {
							that.loginInfo.loginType = 'wx';
							report('12002');
						} else {
							report('12001');
						}
						if (
							typeof window['gCodeServerselect'][that.$actConfig.gameCode] !==
              'undefined'
						) {
							if (
								window['gCodeServerselect'][that.$actConfig.gameCode][
									'type'
								] === 1 &&
                window['gCodeServerselect'][that.$actConfig.gameCode][
                	'partition'
                ] === 0
							) {
								that.queryRole();
							}
						}
						const { gameCode } = this.$actConfig;
						if (gameCode === 'supercore') {
							this.gift();
						}
						document.getElementById('app').classList.add('signin');
						that.queryBind();
						bus.$emit('showNamelist');
						if (
							!that.jsBindIsLoad &&
              typeof window['gCodeServerselect'][that.$actConfig.gameCode] !==
                'undefined' &&
              that.$actConfig.gameCode !== 'tgclub'
						) {
							let loadUrl = `https://gameact.qq.com/comm-htdocs/js/game_area/${
								that.$actConfig.gameCode
							}_server_select.js`;
							that.loadScript(loadUrl, () => {
								that.showPartitionList();
								that.jsBindIsLoad = true;
							});
						}
					},
					() => {
						console.log('未登录2');
					}
				);
			});
		},
		async gift () {
			const [{action: { value }}] = this.gitfIsGeted;
			try {
				const { res: {sOutValue1} } = await this.$doAction('ame', value, {sServiceType: this.$actConfig.gameCode});
				let holdQualiArr = sOutValue1.split('|');
				for (let keyi = 0; keyi < holdQualiArr.length; keyi++) {
					let singleArr = holdQualiArr[keyi].split(' ');
					if (
						typeof this.isGeted.h5['h' + singleArr[0]] ===
                  'undefined'
					) {
						this.isGeted.h5['h' + singleArr[0]] = [];
					}
					this.isGeted.h5['h' + singleArr[0]][0] = singleArr[1];
					this.isGeted.h5['h' + singleArr[0]][1] = singleArr[2];
				}
				bus.$emit('giftReceivedStatus', this.isGeted.h5);
				bus.$emit('enquiryInvitation');
				bus.$emit('getBookQuota');
			} catch (e) {
				console.log(e);
			}
			this.showMode()
		},
		async showMode () {
			try {
				const [{action: { value }}] = this.showType;
				if (value) {
					const {res: { sOutValue1 }} = await this.$doAction('ame', value, {sServiceType: this.$actConfig.gameCode, sPlatId: this.isIos ? '0' : '1'});
					bus.$emit('showtype', sOutValue1);
					if (sOutValue1 == 1) {
						document.getElementById('app').classList.add('android');
					} else {
						document.getElementById('app').classList.add('iostype');
					}
				}
			} catch (e) {
				console.log(e);
			}
		},
		qcLogin () {
			this.$miloLogin().then(LoginManager => {
				LoginManager.login({
					oQQConnectParams: {
						appId: '101813972',
						redirect_uri:
              'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html'
					},
					iUseQQConnect: 1
				});
			});
		},
		wxLogin () {
			this.$miloLogin().then(LoginManager => {
				LoginManager.loginByWX({
					appConfig: {
						WxAppId: 'wxfb66a4e99e630765',
						scope: 'snsapi_userinfo'
					}
				});
			});
		},
		quit () {
			let _self = this;
			this.$miloLogin().then(LoginManager => {
				LoginManager.logout({
					logoutCallback: function () {
						_self.isLogin = false;
						// TODO: 游戏侧跳活动来回刷新，暂时隐藏
						// window.location.reload();
						report('12003');
					}
				});
			});
		},
		// 展示绑定大区
		areaIsShow () {
			this.recordModal = false;
			this.infoModal = false;
			setTimeout(() => {
				if (
					window['gCodeServerselect'][this.$actConfig.gameCode]['type'] === 2 &&
          window['gCodeServerselect'][this.$actConfig.gameCode]['partition'] ===
            1
				) {
					this.areaModalPC = true;
				} else {
					this.areaModal = true;
				}
			}, 500);
		},
		// 关闭绑定大区
		areaModalClose () {
			this.areaModal = false;
			this.areaModalPC = false;
			window.$('#areaModalH5').hide();
			window.$('#areaModalPC').hide();
		},
		// 展示个人信息
		infoIsShow () {
			this.areaModal = false;
			this.recordModal = false;
			this.areaModalPC = false;
			this.infoModal = true;
		},
		// 关闭个人信息
		infoModalClose () {
			this.infoModal = false;
		},
		// 展示获奖记录
		recordIsShow (PageNow = 1, val) {
			PageNow = parseInt(PageNow);
			if (parseInt(PageNow) <= 0 && !val) {
				alert('已经是第一页');
				return;
			} else if (
				PageNow > parseInt(this.awards.totalPage) &&
        this.awards.totalPage >= 0 &&
        !val
			) {
				alert('已经是最后一页');
				return;
			}
			this.areaModal = false;
			this.infoModal = false;
			this.areaModalPC = false;
			this.recordModal = true;
			PageNow = PageNow > 0 ? PageNow : 1;
			this.$doAction('record', this.giftRecordFlowId[0].action.value, {
				iPageSize: 6,
				iPageNow: PageNow
			})
				.then(({ list, allData }) => {
					this.awards.content = [];
					for (let i = 0; i < list.length; i++) {
						let singleGift = {
							name: list[i].sPackageName,
							time: list[i].dtGetPackageTime
						};
						this.awards.content.push(singleGift);
					}
					this.awards.pageNow = PageNow;
					this.awards.totalPage = allData.pageTotal;
					report('12006');
				})
				.catch(e => {
					console.log(e);
					alert(e.sMsg);
				});
		},
		// 关闭获奖记录
		recodeModalClose () {
			this.recordModal = false;
		},
		// 加载js方法
		loadScript (url, callback) {
			let headA = document.getElementsByTagName('head')[0];
			let scriptTag = document.createElement('script');
			scriptTag.type = 'text/javascript';
			scriptTag.src = url;
			scriptTag.charset = 'gbk';
			headA.appendChild(scriptTag);
			scriptTag.onload = () => {
				if (typeof callback === 'function') {
					callback();
				}
			};
		},
		pcQueryRoleHis () {
			// window.amsInit(257026, 606717)
			this.$doAction('ame', this.queryHistoryRoleFlowId[0].action.value, {
				sServiceType: this.$actConfig.gameCode
			})
				.then(({ jData, ...other }) => {
					if (jData.result === 0) {
						let roleMsg = jData.roles;
						this.bindRoleId = roleMsg.roleId;
						this.bindRoleName = decodeURIComponent(roleMsg.roleName);
						this.bindPartitionId = roleMsg.partitionId;
						this.bindPartitionName = decodeURIComponent(roleMsg.partitionName);
						this.areaModal = false;
						this.areaModalPC = false;
						this.area.optTitle = '更改绑定';
						if (!window.bindInfo) {
							window.bindInfo = {};
						}
						window.bindInfo.sArea = roleMsg.partitionId;
						window.bindInfo.sPlatId = roleMsg.platId;
						window.bindInfo.sPartition = roleMsg.partitionId;
						window.bindInfo.sRoleId = roleMsg.roleId;
					}
				})
				.catch(e => {
					console.log(e);
					alert(e.sMsg);
				});
		},
		pcQueryRole () {
			this.$doAction('ame', this.queryRoleFlowId[0].action.value, {
				sArea: 2,
				sPlatId: '2',
				sPartition: this.partitionId,
				sServiceType: this.$actConfig.gameCode
			})
				.then(({ jData, ...other }) => {
					if (typeof jData.roles !== 'undefined') {
						let roleList = JSON.parse(jData.roles);
						this.jobs.content = [];
						if (roleList && roleList.length) {
							for (let i = 0; i < roleList.length; i++) {
								let singleRole = {
									roleId: roleList[i].roleId,
									roleName: decodeURIComponent(roleList[i].roleName)
								};
								this.jobs.content.push(singleRole);
							}
							this.roleId = roleList[0].roleId;
						} else {
							let singleRole = { roleId: '0', roleName: '该服务器无角色' };
							this.jobs.content.push(singleRole);
							this.roleId = '0';
						}
					}
				})
				.catch(e => {
					console.log(e);
					this.jobs.content = [];
					let singleRole = { roleId: '0', roleName: '该服务器无角色' };
					this.jobs.content.push(singleRole);
					this.roleId = '0';
				});
		},
		// 查询角色列表
		queryRole () {
			this.isLogin = true;
			if (window['gCodeServerselect'][this.$actConfig.gameCode]['type']) {
				let partitionListOption = document.getElementById('partition');
				let sPartSelectedIndex = partitionListOption.selectedIndex;
				this.sArea = partitionListOption.options[
					sPartSelectedIndex
				].getAttribute('scid');
				if (this.isIos) {
					this.sPlatId = '2';
				} else {
					this.sPlatId = '1';
				}
				this.jobs.content = [];
				if (parseInt(this.partitionId) <= 0) {
					let singleRole = { roleId: '', roleName: '请选择角色' };
					this.jobs.content.push(singleRole);
					return;
				}
				this.$doAction('ame', this.queryRoleFlowId[0].action.value, {
					sArea: this.sArea,
					sPlatId: this.sPlatId,
					sPartition: this.partitionId,
					sServiceType: this.$actConfig.gameCode
				})
					.then(({ jData, ...other }) => {
						if (typeof jData.roles !== 'undefined') {
							let roleList = JSON.parse(jData.roles);
							this.jobs.content = [];
							window.bindInfo = {
								...window.bindInfo,
								openid: roleList[0].gameOpenId
							}
							if (roleList && roleList.length) {
								for (let i = 0; i < roleList.length; i++) {
									let singleRole = {
										roleId: roleList[i].roleId,
										roleName: decodeURIComponent(roleList[i].roleName)
									};
									this.jobs.content.push(singleRole);
								}
							} else {
								let singleRole = { roleId: '', roleName: '该服务器无角色' };
								this.jobs.content.push(singleRole);
							}
						}
					})
					.catch(e => {
						console.log(e);
						this.jobs.content = [];
						let singleRole = { roleId: '', roleName: '该服务器无角色' };
						this.jobs.content.push(singleRole);
					});
			} else if (
				window['gCodeServerselect'][this.$actConfig.gameCode]['type'] === 1 &&
        window['gCodeServerselect'][this.$actConfig.gameCode]['partition'] === 0
			) {
				if (window.milo.cookie.get('acctype') === 'wx') {
					this.sArea = 1;
				} else {
					this.sArea = 2;
				}
				if (this.isIos) {
					this.sPlatId = '2';
				} else {
					this.sPlatId = '1';
				}
				this.$doAction('ame', this.queryRoleFlowId[0].action.value, {
					sArea: this.sArea,
					sPlatId: this.sPlatId,
					sPartition: '',
					sServiceType: this.$actConfig.gameCode
				})
					.then(({ jData, ...other }) => {
						console.log(jData);
						if (typeof jData.roles !== 'undefined') {
							let roleList = JSON.parse(jData.roles);
							console.log(roleList);
							if (roleList && roleList.length) {
								this.bindRoleId = this.roleId = roleList[0].roleId;
								this.bindRoleName = this.sRoleName = decodeURIComponent(
									roleList[0].roleName
								);
								this.bindPartitionId = this.partitionId =
                  roleList[0].partitionId;
								// this.bindPartitionName = this.sAreaName = decodeURIComponent(roleList[0].partitionName)
								if (!window.bindInfo) {
									window.bindInfo = {};
								}
								window.bindInfo.sArea = this.sArea;
								window.bindInfo.sPlatId = this.sPlatId;
								window.bindInfo.sPartition = this.partitionId;
								window.bindInfo.sRoleId = this.roleId;
							} else {
								alert('暂无游戏角色');
							}
						}
					})
					.catch(e => {
						console.log(e);
						this.jobs.content = [];
						let singleRole = { roleId: '', roleName: '该服务器无角色' };
						this.jobs.content.push(singleRole);
					});
			}
		},
		// 区服信息
		showPartitionList () {
			if (window.gCodeServerselect[this.$actConfig.gameCode].type === 1) {
				// 手游有小区，角色
				if (!window.gCodeServerselect[this.$actConfig.gameCode].partition) { return 0; }
				if (!this.isIos && !this.isAndroid) {
					return 0;
				}
				let ck = window.milo.cookie.get('acctype') === 'wx' ? 'weixin' : 'qq';
				let sk = '';
				if (this.isIos) {
					sk = 'ios';
				} else if (this.isAndroid) {
					sk = 'android';
				}
				let arrOpt =
          window[
          	window.gCodeServerselect[this.$actConfig.gameCode].selectCode +
              'ServerSelect'
          ].STD_DATA;
				console.log(arrOpt);
				console.log(arrOpt.length);
				if (arrOpt) {
					let allPar = '<option value="0">请选择服务器</option>';
					for (let i = 0; i < arrOpt.length; i++) {
						if (arrOpt[i].sk !== sk || arrOpt[i].ck !== ck) continue;
						if (parseInt(arrOpt[i].status) !== 0) {
							allPar +=
                '<option value="' +
                arrOpt[i].v +
                '" scid="' +
                arrOpt[i].c +
                '">' +
                arrOpt[i].t +
                '</option>';
						}
					}
					let domPartition = document.getElementById('partition');
					domPartition.innerHTML = allPar;
				}
			} else if (
				window.gCodeServerselect[this.$actConfig.gameCode].type === 2 &&
        window.gCodeServerselect[this.$actConfig.gameCode].partition === 0
			) {
				// 端游有大区，有角色
				if (
					window[
						window.gCodeServerselect[this.$actConfig.gameCode].selectCode +
              'ServerSelect'
					].STD_DATA
				) {
					let arrOpt =
            window[
            	window.gCodeServerselect[this.$actConfig.gameCode].selectCode +
                'ServerSelect'
            ].STD_DATA;
					let allPar = '<option value="0">请选择服务器</option>';
					for (let i = 0; i < arrOpt.length; i++) {
						if (parseInt(arrOpt[i].status) !== 0) {
							allPar +=
                '<option value="' +
                arrOpt[i].v +
                '" scid="' +
                arrOpt[i].c +
                '">' +
                arrOpt[i].t +
                '</option>';
						}
					}
					let domPartition = document.getElementById('partition');
					domPartition.innerHTML = allPar;
					// TODO: select + options 量级太大，使用 innerHTML 避免低版本手机使用卡顿
				}
			} else if (
				window.gCodeServerselect[this.$actConfig.gameCode].type === 2 &&
        window.gCodeServerselect[this.$actConfig.gameCode].partition === 1
			) {
				// 端游有大区有小区，有角色
				if (
					window[
						window.gCodeServerselect[this.$actConfig.gameCode].selectCode +
              'ServerSelect'
					].STD_DATA
				) {
					let arrOpt =
            window[
            	window.gCodeServerselect[this.$actConfig.gameCode].selectCode +
                'ServerSelect'
            ].STD_DATA;
					let nonePar = { name: '请选择大区', value: -1 };
					this.area.content.push(nonePar);
					for (let i = 0; i < arrOpt.length; i++) {
						let nonePar = { name: arrOpt[i].t, value: arrOpt[i].v };
						this.area.content.push(nonePar);
					}
				}
			}
		},
		// 端游获取小区
		showSenPar () {
			if (
				window[
					window.gCodeServerselect[this.$actConfig.gameCode].selectCode +
            'ServerSelect'
				].STD_DATA
			) {
				let arrOpt =
          window[
          	window.gCodeServerselect[this.$actConfig.gameCode].selectCode +
              'ServerSelect'
          ].STD_DATA;
				this.area.secondPar = [];
				for (let i = 0; i < arrOpt.length; i++) {
					if (parseInt(this.pcArea) === parseInt(arrOpt[i].v)) {
						this.partitionId = arrOpt[i].opt_data_array[0].v;
						for (let j = 0; j < arrOpt[i].opt_data_array.length; j++) {
							let singlePar = {
								name: arrOpt[i].opt_data_array[j].t,
								value: arrOpt[i].opt_data_array[j].v
							};
							this.area.secondPar.push(singlePar);
						}
					}
				}
				if (this.pcArea === -1) {
					this.area.secondPar.push({ name: '请选择小区', value: '0' });
					this.partitionId = '0';
				}
				this.pcQueryRole();
			}
		},
		pcSubBindRole () {
			if (this.roleId == '0') {
				alert('请选择角色');
				return false;
			}
			this.sArea = 2;
			this.sPlatId = '2';
			let sAreaIndex = document.getElementById('pcSenPar').selectedIndex;
			this.sAreaName = document.getElementById('pcSenPar').options[
				sAreaIndex
			].text;
			let sRoleIndex = document.getElementById('pcRole').selectedIndex;
			this.sRoleName = document.getElementById('pcRole').options[
				sRoleIndex
			].text;
			this.$doAction('ame', this.bindRoleFlowId[0].action.value, {
				sArea: this.sArea,
				sPartition: this.partitionId,
				sPlatId: this.sPlatId,
				sRoleId: this.roleId,
				sAreaName: this.sAreaName,
				sRoleName: this.sRoleName,
				sServiceType: this.$actConfig.gameCode
			})
				.then(({ jData, ...other }) => {
					if (jData.result === 0) {
						this.bindRoleId = this.roleId;
						this.bindRoleName = this.sRoleName;
						this.bindPartitionId = this.partitionId;
						this.bindPartitionName = this.sAreaName;
						alert('绑定成功');
						this.areaModal = false;
						this.areaModalPC = false;
						report(this.area.optTitle !== '更改绑定' ? '12004' : '12005');
						this.area.optTitle = '更改绑定';
						if (!window.bindInfo) {
							window.bindInfo = {};
						}
						window.bindInfo.sArea = this.partitionId;
						window.bindInfo.sPlatId = this.sPlatId;
						window.bindInfo.sPartition = this.partitionId;
						window.bindInfo.sRoleId = this.roleId;
						window.$('#areaModalH5').hide();
						window.$('#areaModalPC').hide();
					}
				})
				.catch(e => {
					console.log(e);
					alert(e.sMsg);
				});
		},
		// 提交大区绑定
		subBindRole () {
			let domRole = document.getElementById('role');
			this.roleId = domRole.options[domRole.selectedIndex].value;
			if (this.roleId === '' || this.roleId === '该服务器无角色') {
				alert('请选择角色');
				return;
			}
			if (this.roleId && this.partitionId) {
				if (window.gCodeServerselect[this.$actConfig.gameCode].type) {
					// 手游有小区与角色
					let partitionListOption = document.getElementById('partition');
					let sPartSelectedIndex = partitionListOption.selectedIndex;
					let area = partitionListOption.options[
						sPartSelectedIndex
					].getAttribute('scid');
					const val = partitionListOption.options[
						sPartSelectedIndex
					].getAttribute('value');
					window.bindInfo = { sArea: '', ...window.bindInfo };
					this.sArea =
            area !== 'undefined' ? area : window.bindInfo.sArea || val;
					if (this.isIos) {
						this.sPlatId = '2';
					} else {
						this.sPlatId = '1';
					}
					let sAreaIndex = document.getElementById('partition').selectedIndex;
					this.sAreaName = document.getElementById('partition').options[
						sAreaIndex
					].text;
					let sRoleIndex = document.getElementById('role').selectedIndex;
					this.sRoleName = document.getElementById('role').options[
						sRoleIndex
					].text;
					this.$doAction('ame', this.bindRoleFlowId[0].action.value, {
						sArea: this.sArea,
						sPartition: this.partitionId,
						sPlatId: this.sPlatId,
						sRoleId: this.roleId,
						sAreaName: this.sAreaName,
						sRoleName: this.sRoleName,
						sServiceType: this.$actConfig.gameCode
					})
						.then(({ jData, ...other }) => {
							if (jData.result === 0) {
								this.bindRoleId = this.roleId;
								this.bindRoleName = this.sRoleName;
								this.bindPartitionId = this.partitionId;
								this.bindPartitionName = this.sAreaName;
								alert('绑定成功');
								this.areaModal = false;
								this.areaModalPC = false;
								this.area.optTitle = '更改绑定';
								if (!window.bindInfo) {
									window.bindInfo = {};
								}
								window.bindInfo.sArea = this.sArea;
								window.bindInfo.sPlatId = this.sPlatId;
								window.bindInfo.sPartition = this.partitionId;
								window.bindInfo.sRoleId = this.roleId;
								window.$('#areaModalH5').hide();
								window.$('#areaModalPC').hide();
								bus.$emit('isLogined', true);
								this.gift()
							}
						})
						.catch(e => {
							console.log(e);
							// alert(e.sMsg)
						});
				} else if (
					window.gCodeServerselect[this.$actConfig.gameCode].type === 2 &&
          window.gCodeServerselect[this.$actConfig.gameCode].partition === 0
				) {
					// 端游有大区角色
				} else if (
					window.gCodeServerselect[this.$actConfig.gameCode].type === 2 &&
          window.gCodeServerselect[this.$actConfig.gameCode].partition === 1
				) {
					// 端游有大区有小区角色
				}
			}
		},
		// 查询
		queryBind () {
			let sPlatId;
			if (this.isIos) {
				sPlatId = '2';
			} else {
				sPlatId = '1';
			}
			this.$doAction('ame', this.queryHistoryRoleFlowId[0].action.value, {
				sServiceType: this.$actConfig.gameCode,
				sPlatId: sPlatId
			})
				.then(({ jData, ...other }) => {
					if (jData.result === 0) {
						this.isLogin = true;
						let roleMsg = jData.roles;
						this.bindRoleId = roleMsg.roleId;
						this.bindRoleName = decodeURIComponent(roleMsg.roleName);
						this.bindPartitionId = roleMsg.partitionId;
						this.bindPartitionName = decodeURIComponent(roleMsg.partitionName);
						this.areaModal = false;
						this.areaModalPC = false;
						this.area.optTitle = '更改绑定';
						if (!window.bindInfo) {
							window.bindInfo = {};
						}
						window.bindInfo.sArea = roleMsg.areaId;
						window.bindInfo.sPlatId = roleMsg.platId;
						window.bindInfo.sPartition = roleMsg.partitionId;
						window.bindInfo.sRoleId = roleMsg.roleId;
						window.bindInfo.openid = roleMsg.gameOpenId;
						bus.$emit('isLogined', true);
						this.gift()
					}
				})
				.catch(e => {
					console.log(e);
					alert(e.sMsg);
				});
		},
		getLoginConfig () {
			let loginConfig = {};
			let isMobile = /ipad|iphone|ipod|linux|android/gi.test(
				navigator.userAgent.toLowerCase()
			);
			if (isMobile) {
				loginConfig = {
					iUseQQConnect: window.iUseQQConnect || 1,
					appConfig: {
						WxAppId: 'wxfb66a4e99e630765',
						scope: 'snsapi_userinfo'
					},
					oQQConnectParams: {
						appId: '101813972',
						redirect_uri:
              'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html'
					},
					userinfoSpan: 'userinfo'
				};
			} else {
				loginConfig = {
					oQQConnectParams: {
						appId: '101813972',
						redirect_uri:
              'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html'
					},
					userinfoSpan: 'userinfo',
					iUseQQConnect: 1
				};
			}
			return loginConfig;
		},
		getLogin () {
			if (window.location.href.split('?')[1]) {
				let url = window.location.href.split('?')[1].split('&');
				let data = {};
				for (let i = 0; i < url.length; i++) {
					let arr = url[i].split('=');
					data[arr[0]] = arr[1];
				}
				const { acctype, encode } = data;
				if (acctype && encode) {
					window.Ingame = true;
					const name = acctype === 'weixin' ? '.qq.com' : '.supercore.qq.com';
					data = { ...data, acctype: acctype === 'weixin' ? 'wx' : 'qc' };
					for (let key in data) {
						window.milo.cookie.set(key, data[key], '', name, '/');
					}
				}
			}
		}
	}
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/common.scss";
.actTop_infoText {
  font-size: 0.24rem;
  color: #4a4a4a;
  text-align: center;

  & + .actTop_infoText {
    margin-top: 0.15rem;
  }
}
.actTop_login {
  text-decoration: none;
  color: #4a4a4a;
}

.actTop_InfoUser {
  font-size: 0;
  text-align: center;
  margin-top: 0.34rem;
}
.actTop_InfoLink {
  font-size: 0.24rem;
  color: #4a4a4a;
  margin: 0 0.54rem;
}
.actModal_footer {
  text-align: center;
}
.actModal_footerBtn {
  height: 0.5rem;
  line-height: 0.5rem;
  width: 1.72rem;
  background: #e27f7f;
  @extend %inline-block;
  font-size: 0.28rem;
  color: #4a4a4a;
  margin: 0.1rem 0.16rem 0;
}
.actModal_liIcon {
  height: 0.3rem;
  width: 0.3rem;
  background: #e27f7f;
  @extend %block;
  @extend %absolute;
  top: 50%;
  right: 0.38rem;
  @include translate(0, -50%);
}
.actModal {
  width: 100%;
  height: 100%;
  @extend %fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 6000;
}
.actModal_content {
  width: 6.2rem;
  @extend %absolute;
  left: 50%;
  top: 50%;
  @include translate(-50%, -50%);
  background: #fff;
  padding-bottom: 0.44rem;
  border: 1px solid #979797;
}
.actModal_closeBtn {
  color: #4a4a4a;
  height: 0.5rem;
  width: 0.5rem;
  // background: #e27f7f;
  @extend %block;
  @extend %absolute;
  right: 0.24rem;
  top: 0.2rem;
  span {
    @extend %block;
    width: 0.3rem;
    height: 0.3rem;
    @extend %absolute;
    left: 50%;
    top: 50%;
    @include translate();
  }
}
.actModal_header {
  text-align: center;
  font-size: 0.3rem;
  color: #4a4a4a;
  padding: 0.24rem 0;
  position: relative;
  top: 0.08rem;
  pointer-events: none;
  // border-bottom: 1px solid #4a4a4a;
}
.actModal_li {
  @extend %relative;
  color: #4a4a4a;
  font-size: 0.24rem;
  // border-bottom: 1px solid #4a4a4a;
  // height: 1.04rem;
  // line-height: 1.04rem;
  padding: 0.1rem 0.4rem;
  select {
    width: 100%;
  }
}
.actModal_awardsList {
  margin-top: 0.46rem;
  display: block;
  text-align: center;
  color: #4a4a4a;
  min-height: 1.6rem;
  table {
    width: 100%;
  }
  thead {
    font-size: 0.26rem;
    // border-bottom: 1px solid #666;
  }
  td {
    padding: 0.1rem 0;
  }
  tbody {
    font-size: 0.24rem;
    tr {
      border-bottom: 1px solid #666;
    }
  }
}
.actModal_awardsPages {
  text-align: center;
  margin-top: 0.2rem;
}
.actModal_awardsPagesBtn {
  color: #4a4a4a;
  font-size: 0.24rem;
  line-height: 0.3rem;
  vertical-align: middle;
}
.actModal_awardsPagesInput {
  width: 0.3rem;
  height: 0.3rem;
  border: 1px solid #4a4a4a;
  text-align: center;
  vertical-align: middle;
  // margin: 0 0.26rem;
  margin: 0;
  padding: 0;
  font-size: 0.2rem;
}
.actModal_awardsPagesBtn {
  color: #4a4a4a;
  font-size: 0.24rem;
  line-height: 0.3rem;
  vertical-align: middle;
}
.actModal_bodyTitle {
  font-size: 0.3rem;
  color: #4a4a4a;
  text-align: center;
  margin: 0.5rem 0.8rem 0;
}
.actTop_name {
  max-width: 3rem;
  @extend %inline-block;
  vertical-align: middle;
  @include text-lines();
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/signIn/signin.vue